import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class verificationemployeedataService {
  private _report401kurl = CONFIGURATION.baseServiceUrl + 'reporttracker401kservice/';
  private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';
  constructor(private _http: Http) { }

  getReportData(): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this._report401kurl + 'referencedata', { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }

  get401kreportData(filterCriteria: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    const fileName = 'reportdata?TaxYear=' + filterCriteria.selectedYear
      + '&Proudctioncompany=' + "\'" + filterCriteria.selectedProdCompany + "\'";
    return this._http.get(this._report401kurl + fileName, { headers: headers })
      .map((response: Response) => response.json())
      .catch(this.handleError);
  }
  getSSnData(ssnData: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
      + '&TaxYear=' + ssnData.taxyear
      + '&ControlGroup=' + ssnData.controlgroup
      + '&ReportName=' + '401kReport';
    return this._http.get(this._ssnUrl + fileName, { headers: headers })
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  downloadExcelReport(filterCriteria: any): any {
    const fileName = 'excel-download?TaxYear=' + filterCriteria.selectedYear
      + '&Proudctioncompany=' + "\'" + filterCriteria.selectedProdCompany + "\'";
    const url = this._report401kurl + fileName
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const blob = new Blob([res.blob()], { type: 'application/zip' });
        const downloadUrl = URL.createObjectURL(blob);
        window.open(downloadUrl);
      })

  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }

}



// WEBPACK FOOTER //
// ./src/app/verificationofemployeedata/verificationofemployeedata.service.ts